import type { TourStep } from '../types';

export const usingCalendarSteps: TourStep[] = [
  {
    target: '[data-tour="calendar-header"]',
    title: 'Your Calendar',
    content:
      'The calendar automatically syncs with appraisal due dates and scheduled inspections. You can also create custom events for meetings, deadlines, or reminders.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="calendar-new-event"]',
    title: 'Create an Event',
    content:
      'Click here to add a custom event — appointments, meetings, or personal reminders. Appraisal due dates are added automatically when you create or update an appraisal.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ll try later',
  },
  {
    target: '[data-tour="calendar-views"]',
    title: 'Switch Views',
    content:
      'Try switching between Month, Week, Day, and Agenda. Agenda gives you a clean chronological list — great for planning your week.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve tried it',
  },
  {
    target: '[data-tour="calendar-nav"]',
    title: 'Navigate Dates',
    content:
      'Use the arrows to move forward or backward. The "Today" button snaps you back to the current date.',
    placement: 'bottom',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="calendar-filters"]',
    title: 'Filter Events',
    content:
      'Filter by type (due dates, inspections, custom events) or search for a specific property address or file number. Try filtering to see how it works.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Got it',
  },
  {
    target: '[data-tour="calendar-legend"]',
    title: 'Color Legend',
    content:
      'Events are color-coded: blue for due dates, green for inspections, purple for custom events, and red for overdue items.',
    placement: 'top',
  },
  {
    target: '[data-tour="calendar-team"]',
    title: 'Team Overlay',
    content:
      'If you\'re part of a team, toggle this to overlay your teammates\' events. Great for coordinating inspections and avoiding scheduling conflicts.',
    placement: 'bottom',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="calendar-summary"]',
    title: 'Summary Bar',
    content:
      'A quick count of events for the selected period — due dates, inspections, and custom events coming up.',
    placement: 'top',
  },
];
